import { Component }      from '@angular/core';
import { ViewController } from 'ionic-angular';
import { CrawlService }   from "../../services/crawl.service";
import { MiscService }    from "../../services/misc.service";
import { Book }           from "../../models/book";

@Component({
  selector: 'dra-add-book',
  templateUrl: 'add-book.component.html',
})
export class AddBookComponent {
  public source: string = 'uukanshu';
  public sourceId: string;

  public constructor(
    private viewController: ViewController,
    private crawlService: CrawlService,
    private miscService: MiscService,
  ) {
  }

  public async crawlBook(source: string, sourceId: string): Promise<void> {
    try {
      this.miscService.startLoading();

      let book: Book = await this.crawlService.getBook(source, sourceId);

      this.miscService.stopLoading();

      this.viewController.dismiss(book);
    } catch (error) {
      this.miscService.stopLoading();
      this.miscService.error(error.message);
    }
  }

  public dismiss(): void {
    this.viewController.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/components/add-book/add-book.component.ts